<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-app-notification`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 20a8 8 0 110-16 8 8 0 010 16zm2 2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V42a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h19.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H8v30h29a1 1 0 001-1V22.5zM40 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
</template>
<script>

export default {
  name: 'IconAppNotification',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
